import * as m from 'moment-timezone'
import { extendMoment } from 'moment-range';
extendMoment(m)

const moment = m

import 'moment-duration-format'

export default moment